<template>
  <section class="board-tab2" :style="dBHeight">
    <h2 class="hide">{{$i18nUtil.trans("entity.todo","할 일")}}</h2>
    <div class="board-tit1">{{$i18nUtil.trans("title.BoardTodo.001","할 일 내역")}}</div>
    <div class="tb-list_ty1">
      <div class="tb-header clear">
        <div class="tb_num fl" v-html="$i18nUtil.trans('search.000','총 {cnt}건', {cnt: todoLength})">
        </div>
        <div class="tb_sort fr">
          <input
            type="checkbox"
            id="re"
            v-model="option.request"
            @change="getList()"
          /><label for="re">{{ $i18nUtil.trans("title.BoardTodo.002","내가 한 요청") }}</label>
          <input
            type="checkbox"
            id="de"
            v-model="option.getRequest"
            @change="getList()"
          /><label for="de">{{ $i18nUtil.trans("title.BoardTodo.003","내가 받은 요청") }}</label>
          <div class="dividing_line_ty2"></div>
          <dl class="dl_layer select_ty1">
            <dt>
              <button
                type="button"
                @click="$event.target.parentElement.classList.toggle('active')"
              >
                {{ $i18nUtil.trans("message.BoardTodo.003","상태 {state}", {state: state}) }}
              </button>
            </dt>
            <dd style="width:80px">
              <ul>
                <li class="active" id="boardTodoState" @click="stateChking('')">
                  <button type="button">{{ $i18nUtil.trans("entity.todo.filter.all","전체") }}</button>
                </li>
                <li id="boardTodoStateP" @click="stateChking('P')">
                  <button type="button">{{ $i18nUtil.trans("entity.todo.filter.request","요청") }}</button>
                </li>
                <li id="boardTodoStateC" @click="stateChking('C')">
                  <button type="button">{{ $i18nUtil.trans("entity.todo.filter.complete","완료") }}</button>
                </li>
                <li id="boardTodoStateD" @click="stateChking('D')">
                  <button type="button">{{ $i18nUtil.trans("entity.todo.filter.delete","삭제") }}</button>
                </li>
              </ul>
            </dd>
          </dl>
          <dl class="dl_layer select_ty1">
            <dt>
              <button
                type="button"
                @click="$event.target.parentElement.classList.toggle('active')"
              >
                {{ $i18nUtil.trans("entity.todo.requester","요청자") }} {{ requesterSelect }}
              </button>
            </dt>
            <dd style="width:145px">
              <ul>
                <li class="active" id="boardTodoReq" @click="reqChking('')">
                  <button type="button">{{ $i18nUtil.trans("entity.todo.filter.all","전체") }}</button>
                </li>
                <li
                  v-for="(req, index) in requester"
                  :key="index"
                  :transfer-data="req"
                  v-if="userInfo.userId == req.userId"
                  :id="'boardTodoReq' + req.userId"
                  @click="reqChking(req)"
                >
                  <button type="button">{{ $i18nUtil.trans("message.BoardTodo.004","{user}(본인)", {user: req.userName}) }}</button>
                </li>
                <li
                  v-for="(req2, index) in requester"
                  :key="index"
                  :transfer-data="req2"
                  v-if="userInfo.userId != req2.userId"
                  :id="'boardTodoReq' + req2.userId"
                  @click="reqChking(req2)"
                >
                  <button type="button">
                    {{ req2.userName }}
                  </button>
                </li>
              </ul>
            </dd>
          </dl>
          <dl class="dl_layer select_ty1">
            <dt>
              <button
                type="button"
                @click="$event.target.parentElement.classList.toggle('active')"
              >
                {{ $i18nUtil.trans("entity.todo.personInCharge","담당자") }} {{ chargerSelect }}
              </button>
            </dt>
            <dd style="width:145px">
              <ul>
                <li class="active" id="boardTodoChar" @click="charChking('')">
                  <button type="button">{{ $i18nUtil.trans("entity.todo.filter.all","전체") }}</button>
                </li>
                <li
                  v-for="(char, index) in charger"
                  :key="index"
                  :transfer-data="char"
                  v-if="userInfo.userId == char.userId"
                  :id="'boardTodoChar' + char.userId"
                  @click="charChking(char)"
                >
                  <button type="button">{{ $i18nUtil.trans("message.BoardTodo.004","{user}(본인)", {user: char.userName}) }}</button>
                </li>
                <li
                  v-for="(char, index) in charger"
                  :key="index"
                  :transfer-data="char"
                  v-if="userInfo.userId != char.userId"
                  :id="'boardTodoChar' + char.userId"
                  @click="charChking(char)"
                >
                  <button type="button">
                    {{ char.userName }}
                  </button>
                </li>
              </ul>
            </dd>
          </dl>
        </div>
      </div>
      <div>
        <!-- v-data-table 로 작업된 화면 -->
        <!-- 데이터 없음 S -->
        <v-data-table
          v-model="selected"
          :items="desserts"
          :single-select="singleSelect"
          show-select
          :page.sync="page"
          :items-per-page="itemsPerPage"
          @page-count="pageCount = $event"
          hide-default-header
          hide-default-footer
          class="tb-contents bds_032"
        >
          <template v-slot:item="{ item }">
            <tr :class="item.isState">
              <td class="txtc">
                <input
                  type="checkbox"
                  :id="'ch-' + item.id"
                  @click="boxchecking(item)"
                /><label :for="'ch-' + item.id"></label>
              </td>
              <td class="txtc" :class="item.isState">{{ item.statusTxt }}</td>
              <td class="txtc">
                <div class="re-de">
                  <div class="re">{{ item.re }}</div>
                  <div class="division"></div>
                  <div class="de">{{ item.de }}</div>
                </div>
              </td>
              <td class="subject">
                <div class="txt ell-singleline">{{ item.subject }}</div>
                <div class="reason">{{ item.reason }}</div>
              </td>
              <td class="date txtc" :class="item.dateStatus">
                {{ item.date }}
              </td>
              <td class="txtc">
                <dl class="more_box small">
                  <dt :id="'more_box' + item.id">
                    <button
                      type="button"
                      class="more"
                      @click="
                        $event.target.parentElement.classList.toggle('active')
                      "
                    >
                      {{ $i18nUtil.trans("button.more","더보기") }}
                    </button>
                  </dt>
                  <dd style="width: 80px;">
                    <ul>
                      <li><button type="button">{{$i18nUtil.trans("button.todo.copy","할 일 복제")}}</button></li>
                      <li><button type="button" @click="openModal(item)">{{$i18nUtil.trans("button.todo.delete","할 일 삭제")}}</button></li>
                    </ul>
                  </dd>
                </dl>
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <div class="nodata-txt todo">
              <v-alert :value="true">
                {{$i18nUtil.trans("search.037","등록된 할 일이 없습니다.")}}
              </v-alert>
            </div>
          </template>
        </v-data-table>
        <!-- //데이터 없음 E --><br /><br /><br /><br />

        <v-pagination
          v-model="page"
          circle
          :length="pageCount"
          :total-visible="7"
        ></v-pagination>
        <!-- //v-data-table 로 작업된 화면 -->
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import DeleteModal from "../modal/TodoDeleteModal";
import EventBus from "@/js/eventbus/eventBus";
import { set } from "vuedraggable";
export default {
  components: {},
  data() {
    return {
      dBHeight: {
        "min-height": window.innerHeight + 310 + "px"
      },
      /* tenantId */
      tenantId: localStorage.getItem("tenantId"),
      todoLength: 0,
      modal: false,
      view: true,
      page: 1,
      page2: 1,
      pageCount: 0,
      itemsPerPage: 20,
      singleSelect: false,
      state: this.$i18nUtil.trans("entity.todo.filter.all","전체"),
      requesterSelect: this.$i18nUtil.trans("entity.todo.filter.all","전체"),
      chargerSelect: this.$i18nUtil.trans("entity.todo.filter.all","전체"),
      requester: [],
      charger: [],
      option: {
        request: false,
        getRequest: false,
        state: null,
        requester: [],
        charger: []
      },
      userInfo: {
        userId: null,
        userName: null
      },
      selected: [],
      desserts: [
        {
          id: 0,
          isState: "",
          status: "",
          statusTxt: "",
          subject: "",
          reason: "",
          re: "",
          de: "",
          date: "",
          dateStatus: null
        }
      ]
    };
  },
  mounted() {
    this.getUserInfo();
  },
  created() {
    EventBus.$on("getBoardTodoList", payload => {
      this.getList();
    });
  },
  methods: {
    ...mapActions("modals", ["showModal"]),
    openModal(param) {
      const modalInfo = {
        name: "DeleteModal",
        obj: this.$modal,
        component: DeleteModal,
        width: "500px",
        height: "287px",
        item: param
      };
      this.showModal(modalInfo);
      document.getElementById("more_box" + param.id).classList.toggle("active");
    },
    closeModal() {
      this.modal = false;
    },
    async getList() {
      let boardindex = [];
      let boardindexTodo = {
        id: 0,
        isState: "",
        status: "",
        statusTxt: "",
        subject: "",
        reason: "",
        re: "",
        de: "",
        date: null,
        dateStatus: null,
        todoStatus: null,
        regUserId: null,
        chargerId: null
      };
      let paramPaperUserList = {
        paperId: this.$route.params.paperId
        // option: this.option
      };
      let regUserInfo = {
        userId: null,
        userName: null
      };
      let chargerInfo = {
        userId: null,
        userName: null
      };
      let user = [];
      let charger = [];
      let today = new Date();
      let url = "/api/copaper/todo/list_board";
      this.$axios.post(url, paramPaperUserList).then(response => {
        if(response.data.result != null) {
          this.todoLength = response.data.result.length;
          for (let i = 0; i < response.data.result.length; i++) {
            boardindexTodo = {
              id: 0,
              isState: "",
              status: "",
              statusTxt: "",
              subject: "",
              reason: "",
              re: "",
              de: "",
              date: null,
              dateStatus: null,
              todoStatus: null,
              regUserId: null,
              chargerId: null
            };
            regUserInfo = {
              userId: null,
              userName: null
            };
            chargerInfo = {
              userId: null,
              userName: null
            };
            boardindexTodo.id = response.data.result[i].todoId;
            boardindexTodo.subject = response.data.result[i].todoTitle;
            boardindexTodo.re = response.data.result[i].regUserName;
            boardindexTodo.de = response.data.result[i].chargerName;
            boardindexTodo.reason = response.data.result[i].delReason;
            boardindexTodo.date = this.replaceAll(
              response.data.result[i].todoEndDate,
              "-",
              "."
            );

            regUserInfo.userId = response.data.result[i].regUserId;
            regUserInfo.userName = response.data.result[i].regUserName;

            chargerInfo.userId = response.data.result[i].chargerId;
            chargerInfo.userName = response.data.result[i].chargerName;

            var dateArray = response.data.result[i].todoEndDate.split(".");
            var dateObj = new Date(
              dateArray[0],
              Number(dateArray[1]) - 1,
              dateArray[2]
            );
            var betweenDay =
              (today.getTime() - dateObj.getTime()) / 1000 / 60 / 60 / 24;
            if (betweenDay < 3) {
              boardindexTodo.dateStatus = "deadline";
            }

            boardindexTodo.todoStatus = response.data.result[i].todoStatus;
            boardindexTodo.regUserId = response.data.result[i].regUserId;
            boardindexTodo.chargerId = response.data.result[i].chargerId;
            if (response.data.result[i].todoStatus == "P") {
              boardindexTodo.isState = "request";
              boardindexTodo.status = "request";
              boardindexTodo.statusTxt = this.$i18nUtil.trans("entity.todo.filter.request","요청");
            } else if (response.data.result[i].todoStatus == "C") {
              boardindexTodo.isState = "fin";
              boardindexTodo.status = "fin";
              boardindexTodo.statusTxt = this.$i18nUtil.trans("entity.todo.filter.complete","완료");
            } else {
              boardindexTodo.isState = "del";
              boardindexTodo.status = "del";
              boardindexTodo.statusTxt = this.$i18nUtil.trans("entity.todo.filter.delete","삭제");
            }
            var userChk = true;
            for (let i = 0; i < user.length; i++) {
              if (user[i].userId == regUserInfo.userId) {
                userChk = false;
              }
            }
            if (userChk) {
              user.push(regUserInfo);
            }
            var chargerChk = true;
            for (let i = 0; i < charger.length; i++) {
              if (charger[i].userId == chargerInfo.userId) {
                chargerChk = false;
              }
            }
            if (chargerChk) {
              charger.push(chargerInfo);
            }

            if (this.optionCkeck(boardindexTodo)) {
              boardindex.push(boardindexTodo);
            }
            this.view = false;
          }

          this.requester = user;
          this.charger = charger;
          this.desserts = boardindex;
          }
      });
    },
    boxchecking(param) {
      if (param.chargerId != this.userInfo.userId) {
        document.getElementById("ch-" + param.id).checked = false;
        return false;
      }
      let para = { todoId: param.id };
      let url = "/api/copaper/todo/complete";
      this.$axios.post(url, para).then(response => {
        this.getList();
      });
    },
    stateChking(param) {
      document.getElementById("boardTodoState").setAttribute("class", "");
      document.getElementById("boardTodoStateP").setAttribute("class", "");
      document.getElementById("boardTodoStateC").setAttribute("class", "");
      document.getElementById("boardTodoStateD").setAttribute("class", "");
      if (param == "") {
        this.state = this.$i18nUtil.trans("entity.todo.filter.all","전체");
        document
          .getElementById("boardTodoState")
          .setAttribute("class", "active");
        this.option.state = null;
      } else if (param == "P") {
        this.state = this.$i18nUtil.trans("entity.todo.filter.request","요청");
        document
          .getElementById("boardTodoStateP")
          .setAttribute("class", "active");
        this.option.state = "P";
      } else if (param == "C") {
        this.state = this.$i18nUtil.trans("entity.todo.filter.complete","완료");
        document
          .getElementById("boardTodoStateC")
          .setAttribute("class", "active");
        this.option.state = "C";
      } else {
        this.state = this.$i18nUtil.trans("entity.todo.filter.delete","삭제");
        document
          .getElementById("boardTodoStateD")
          .setAttribute("class", "active");
        this.option.state = "D";
      }
      this.getList();
    },
    reqChking(param) {
      if (param == "") {
        for (let i = 0; i < this.requester.length; i++) {
          document
            .getElementById("boardTodoReq" + this.requester[i].userId)
            .setAttribute("class", "");
        }
        document.getElementById("boardTodoReq").setAttribute("class", "active");
        this.requesterSelect = this.$i18nUtil.trans("entity.todo.filter.all","전체");
      } else {
        document.getElementById("boardTodoReq").setAttribute("class", "");
        document
          .getElementById("boardTodoReq" + param.userId)
          .classList.toggle("active");
        this.requesterSelect = this.$i18nUtil.trans("entity.todo.filter.select","선택");
      }
      this.setRequerter(param);
    },
    charChking(param) {
      if (param == "") {
        for (let i = 0; i < this.charger.length; i++) {
          document
            .getElementById("boardTodoChar" + this.charger[i].userId)
            .setAttribute("class", "");
        }
        document
          .getElementById("boardTodoChar")
          .setAttribute("class", "active");
        this.chargerSelect = this.$i18nUtil.trans("entity.todo.filter.all","전체");
      } else {
        document.getElementById("boardTodoChar").setAttribute("class", "");
        document
          .getElementById("boardTodoChar" + param.userId)
          .classList.toggle("active");
        this.chargerSelect = this.$i18nUtil.trans("entity.todo.filter.select","선택");
      }
      this.setCharger(param);
    },
    getUserInfo() {
      let url = "/api/copaper/decision/userInfo";
      this.$axios.post(url).then(response => {
        this.userInfo = response.data.result;
        this.getList();
      });
    },
    setRequerter(param) {
      let requesterList = this.option.requester;
      if (param == "") {
        this.option.requester = [];
      } else {
        let doubleCheck = true;
        for (let i = 0; i < requesterList.length; i++) {
          if (requesterList[i] == param.userId) {
            doubleCheck = false;
            requesterList.splice(i, 1);
          }
        }
        if (doubleCheck) {
          requesterList.push(param.userId);
        }
        this.option.requester = requesterList;
      }
      if (requesterList.length <= 0) {
        document.getElementById("boardTodoReq").setAttribute("class", "active");
        this.requesterSelect = this.$i18nUtil.trans("entity.todo.filter.all","전체");
      }
      this.getList();
    },
    setCharger(param) {
      let chargerList = this.option.charger;
      if (param == "") {
        this.option.charger = [];
      } else {
        let doubleCheck = true;
        for (let i = 0; i < chargerList.length; i++) {
          if (chargerList[i] == param.userId) {
            doubleCheck = false;
            chargerList.splice(i, 1);
          }
        }
        if (doubleCheck) {
          chargerList.push(param.userId);
        }
        this.option.charger = Array.from(new Set(chargerList));
      }
      if (chargerList.length <= 0) {
        document
          .getElementById("boardTodoChar")
          .setAttribute("class", "active");
        this.chargerSelect = this.$i18nUtil.trans("entity.todo.filter.all","전체");
      }
      this.getList();
    },
    optionCkeck(param) {
      let opt = this.option;
      let returnValue = true;
      if (opt.request) {
        if (param.regUserId != this.userInfo.userId) {
          returnValue = false;
        }
      }
      if (opt.getRequest) {
        if (param.chargerId != this.userInfo.userId) {
          returnValue = false;
        }
      }
      if (opt.state != null) {
        if (param.todoStatus != opt.state) {
          returnValue = false;
        }
      }
      if (opt.requester.length > 0) {
        returnValue = false;
        for (let i = 0; i < opt.requester.length; i++) {
          if (param.regUserId == opt.requester[i]) {
            returnValue = true;
          }
        }
      }
      if (opt.charger.length > 0) {
        returnValue = false;
        for (let i = 0; i < opt.charger.length; i++) {
          if (param.chargerId == opt.charger[i]) {
            returnValue = true;
          }
        }
      }
      return returnValue;
    },
    replaceAll(str, input, output) {
      return str.split(input).join(output);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/general/board/todo/BoardTodo.vue